<template>
  <div class='wechat'>
    <img src="../../assets/img/wechatCode.jpg" alt="">
  </div>
</template>

<script>
 export default {
   data() {
     return {}
   },
   components: {},
   created() {},
   computed: {},
   mounted() {},
   methods: {},
  }
</script>
<style  scoped lang="less">
.wechat{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Wechat.vue